"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotificationSettingsDto = void 0;
const UserDto_1 = require("../users/UserDto");
class AlertNotificationSettingsDto {
    constructor(params) {
        this.alertType = "";
        this.alertEnabled = false;
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.alertType = params.alertType;
        this.alertEnabled = params.alertEnabled;
        this.userId = params.userId;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.user !== undefined) {
            this.user = params.user ? new UserDto_1.UserDto(params.user) : null;
        }
    }
}
exports.AlertNotificationSettingsDto = AlertNotificationSettingsDto;
//# sourceMappingURL=AlertNotificationSettingsDto.js.map